// i18n area 'hci' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.nl-NL.meta.json.
import type { enUS } from './hci'

export const nlNL: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-clusters',
      createButton: 'Ceph-cluster aanmaken',
      emptyTitle: 'Nog geen beheerd Ceph-cluster',
      emptyBody: 'TVirt rolt Ceph uit op de lidnodes en is er eigenaar van, hyperconverged met de VM-werklast. Maak een cluster aan: de eerste monitor en zijn manager ontstaan automatisch op de gekozen controlenode — laat het daarna groeien met meer monitors en OSD-apparaten.',
      pageTitle: 'Ceph-clusters',
      colState: 'Status',
      colMembers: 'Leden',
      colSize: 'Grootte',
      colVersion: 'Ceph-versie',
      sizeCell: '{used} GiB gebruikt van {total} GiB totaal',
      phase: {
        'not-deployed': 'Niet uitgerold',
        deploying: 'Wordt uitgerold',
        healthy: 'Gezond',
        degraded: 'Gedegradeerd',
        error: 'Fout',
        destroying: 'Wordt vernietigd',
        destroyed: 'Vernietigd'
      },
      health: {
        HEALTH_OK: 'Gezond (HEALTH_OK)',
        HEALTH_WARN: 'Met waarschuwingen (HEALTH_WARN)',
        HEALTH_ERR: 'In fout (HEALTH_ERR)',
        unknown: 'Nog niet waargenomen',
        observedAt: 'waargenomen {time}'
      },
      create: {
        title: 'Ceph-cluster aanmaken',
        info: "Bij het aanmaken van een nieuw Ceph-cluster kies je de eerste node waarop de rollen MON en MGR worden geïnstalleerd. Je geeft ook aan welk subnet het Ceph-verkeer moet dragen: het public-subnet draagt het algemene netwerkverkeer, terwijl het cluster-subnet de interne replica's tussen de OSD's draagt; verschillende subnetten zijn niet per se nodig.",
        controlNode: 'Controlenode',
        controlNodeHint: 'De lidnode waar de eerste MON + MGR ontstaan.',
        publicSubnet: 'Public-subnet',
        publicSubnetHint: 'Een Subnet dat in de IPAM is geregistreerd — de public_network van Ceph. Onveranderlijk na het aanmaken.',
        clusterSubnet: 'Cluster-subnet',
        clusterSubnetHint: 'Een Subnet dat in de IPAM is geregistreerd — de cluster_network van Ceph (replicatie/backfill).',
        noSubnets: 'Geen enkel Subnet geregistreerd — maak ze eerst aan in de IPAM',
        sameSubnet: 'Hetzelfde subnet voor public- en clusterverkeer',
        sameSubnetHint: 'Aangevinkt = het clusternetwerk (replicatie/backfill) valt samen met het public-netwerk. Niet aangevinkt = kies zijn eigen subnet ÉN het adres van de controlenode daarbinnen.',
        controlAddress: 'Adres van de controlenode',
        controlAddressHint: 'Een adres dat de IPAM voor de node kent binnen het public-subnet.',
        controlClusterAddress: 'Cluster-adres van de controlenode',
        controlClusterAddressHint: 'Een adres dat de IPAM voor de node kent binnen het cluster-subnet.',
        noAddresses: 'De IPAM kent geen enkel adres van deze node binnen het gekozen subnet',
        started: 'Cluster aangemaakt — de bootstrap gaat verder als macrotask; de fase volgt vanzelf',
        error: 'Het cluster is geweigerd'
      },
      detail: {
        actions: 'Beschikbare acties',
        tabOverview: 'Overzicht',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pools',
        tabObjects: 'Objecten',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Geavanceerd',
        phase: 'Fase',
        checksTitle: 'Actieve health checks',
        noChecks: 'Geen actieve health check',
        checkMuted: 'gedempt',
        summaryPools: 'Pools',
        summaryFilesystems: 'Bestandssystemen',
        nodesCard: 'Nodes',
        monHint: "Bij elke MON draait een MGR mee op dezelfde node (colocatie). Drie MON's zijn het aanbevolen quorum; een labcluster start met één. OSD's en MDS-daemons wonen op hun eigen tabbladen.",
        monHintSplit: "MON en MGR staan op dit cluster los van elkaar (Geavanceerd): elke rol is een eigen lidmaatschap per node. Drie MON's zijn het aanbevolen quorum; er moet minstens één MGR bestaan.",
        noMons: 'Nog geen monitor gedeclareerd',
        addNode: 'Node toevoegen',
        removeNode: 'Node weghalen',
        removeNodeFrom: 'Node {node} weghalen (zijn MON en de MGR die ernaast draait)',
        roleMon: 'Rol MON',
        roleMgr: 'Rol MGR',
        roleNa: 'N.v.t.',
        roleNotObserved: 'nog niet waargenomen',
        monInQuorum: 'in het quorum',
        monOutQuorum: 'buiten het quorum',
        mgrActive: 'actief',
        mgrStandby: 'standby',
        addRoleMon: 'Rol MON toevoegen',
        removeRoleMon: 'Rol MON weghalen',
        addRoleMgr: 'Rol MGR toevoegen',
        removeRoleMgr: 'Rol MGR weghalen',
        restartMon: 'MON-dienst herstarten',
        restartMgr: 'MGR-dienst herstarten',
        addMon: 'MON toevoegen',
        removeMon: 'MON weghalen',
        removeMonFrom: 'De rol MON weghalen bij {node}',
        addMgr: 'MGR toevoegen',
        removeMgr: 'MGR weghalen',
        removeMgrFrom: 'De rol MGR weghalen bij {node}',
        addMds: 'MDS toevoegen',
        removeMds: 'MDS weghalen',
        removeMdsFrom: 'De rol MDS weghalen bij {node}',
        mdsSection: 'Metadataservers (MDS)',
        noMds: 'Nog geen MDS gedeclareerd — een bestandssysteem vraagt er eerst één',
        mdsHint: "Het MDS-lidmaatschap staat vanaf dag één op zichzelf: een cluster zonder CephFS declareert er geen, één actieve plus één standby bedienen een bestandssysteem prima. Ceph kiest actieven en standby's uit de gedeclareerde daemons.",
        mdsActiveFor: 'actief — {fs}',
        mdsNotObserved: 'nog niet waargenomen',
        lastMdsGuard: 'De laatste MDS kan niet weg zolang er een bestandssysteem bestaat — haal eerst de bestandssystemen weg',
        lastMonGuard: 'De laatste MON kan niet weg — het cluster vernietigen is de enige uitgang',
        lastMgrGuard: 'De laatste MGR kan niet weg — een beheerd cluster draait nooit zonder manager',
        registerDevice: 'OSD toevoegen',
        unregisterDevice: 'Deregistreren',
        activeDeviceGuard: 'Actieve OSD — hij vertrekt via de levenscyclus van de OSD, niet via het register',
        colNode: 'Node',
        devicePhase: { registered: 'Geregistreerd', active: 'Actief' },
        health: 'Gezondheid',
        state: 'Status',
        fsid: 'fsid',
        fsidPending: 'afwezig — probeer de bootstrap opnieuw',
        version: 'Ceph-versie',
        publicNetwork: 'Public-netwerk',
        clusterNetwork: 'Cluster-netwerk',
        clusterNetworkCollapsed: '= public',
        noActions: 'In deze fase is geen actie beschikbaar',
        destroyedNote: 'Cluster vernietigd — de rij verdwijnt zo meteen automatisch'
      },
      overview: {
        services: 'Diensten',
        ok: 'gezond',
        warning: 'waarschuwing',
        down: 'down',
        pgTitle: "Statussen van de PG's",
        pgTotal: "{n} PG's in totaal",
        capacityTitle: 'Ruimte',
        ioTitle: 'Huidige I/O',
        ioReadBw: 'Leesbandbreedte',
        ioWriteBw: 'Schrijfbandbreedte',
        ioReadIops: 'Lees-IOPS',
        ioWriteIops: 'Schrijf-IOPS',
        notObserved: 'nog niet waargenomen'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Status',
        colSize: 'Grootte',
        colPgs: "PG's",
        empty: 'Nog geen OSD — voeg er een toe vanaf een gedeclareerde dataschijf',
        markIn: 'Markeren als IN',
        markOut: 'Markeren als OUT',
        scrub: 'Scrub uitvoeren',
        deepScrub: 'Diepe scrub uitvoeren',
        restart: 'Dienst herstarten',
        details: 'Details',
        actionGuard: 'Alleen op een actieve OSD van een uitgerold cluster',
        inTitle: 'OSD als IN markeren',
        inBody: 'osd.{id} keert terug in de dataverdeling (ceph osd in): Ceph balanceert de data weer naar hem toe.',
        outTitle: 'OSD als OUT markeren',
        outBody: 'osd.{id} verlaat de dataverdeling (ceph osd out): zijn data wordt elders herbalanceerd en de redundantie is VERLAAGD zolang de backfill loopt. Op elk moment omkeerbaar met Markeren als IN.',
        scrubTitle: 'Scrub inplannen',
        scrubBody: 'Er wordt een scrub van osd.{id} ingepland: de mon zet hem in de wachtrij en de PG-statussen van de volgende sweeps vertellen de afloop.',
        deepScrubTitle: 'Diepe scrub inplannen',
        deepScrubBody: 'Er wordt een diepe scrub van osd.{id} ingepland: de variant die de bytes verifieert — zwaarder op de I/O, dezelfde werking.',
        restartTitle: 'OSD-dienst herstarten',
        restartBody: 'osd.{id} wordt gestopt en weer gestart onder het toezicht van de worker op zijn node.',
        started: 'Actie gestart — de waarneming volgt vanzelf',
        error: 'De OSD-actie is geweigerd'
      },
      osdDetail: {
        title: 'OSD-details',
        tabGeneral: 'Algemeen',
        tabNetwork: 'Netwerk',
        tabDevices: 'Apparaten',
        version: 'Versie',
        hostname: 'Hostname',
        dataPath: 'Datapad van de OSD',
        objectStore: 'Object store van de OSD',
        encrypted: 'Versleuteld',
        yes: 'Ja',
        no: 'Nee',
        memory: 'Geheugengebruik (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front-adres (client & monitor)',
        hbFront: 'Heartbeat-front-adres',
        back: 'Back-adres (OSD)',
        hbBack: 'Heartbeat-back-adres',
        colDevice: 'Device',
        colType: 'Type',
        colPhysical: 'Fysiek device',
        colSize: 'Grootte',
        volumeTitle: 'Details van het volume',
        creationTime: 'Aanmaakdatum',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Geen device waargenomen voor deze OSD'
      },
      restart: {
        title: 'Dienst herstarten',
        monBody: 'De MON-daemon op {node} wordt gestopt en weer gestart onder het toezicht van de worker.',
        mgrBody: 'De MGR-daemon op {node} wordt gestopt en weer gestart onder het toezicht van de worker.',
        started: 'Herstart gestart — de waarneming volgt vanzelf',
        error: 'De herstart is geweigerd'
      },
      encryptionMode: {
        alwaysOn: 'Altijd ingeschakeld (dmcrypt)',
        alwaysOff: 'Altijd uitgeschakeld',
        perOsd: 'Per OSD gekozen',
        section: 'OSD-versleuteling at rest',
        title: 'Modus van de OSD-versleuteling wijzigen',
        hint: "Hoe NIEUWE OSD's worden voorbereid. Bestaande OSD's houden hun toestand per schijf: om die te wijzigen haal je de OSD weg en maak je hem opnieuw aan.",
        body: 'De modus wordt "{mode}" en geldt ALLEEN voor NIEUWE OSD\'s: elke bestaande OSD houdt zijn huidige versleutelingstoestand.',
        apply: 'Modus wijzigen',
        error: 'De moduswijziging is geweigerd'
      },
      pin: {
        address: 'Public-adres (optionele pin)',
        clusterAddress: 'Cluster-adres (optionele pin)',
        autoPlaceholder: 'automatisch in het subnet {cidr}',
        hint: 'Adressering per daemon: leeg = Ceph hecht zichzelf aan binnen het gedeclareerde netwerk; ingevuld = deze instantie wordt vastgepind op het adres in zijn eigen conf-sectie.'
      },
      addMon: {
        title: 'Node toevoegen',
        node: 'Node',
        address: 'Public-adres',
        addressHint: 'De adressen van de node die de IPAM binnen het public-subnet kent — automatisch wanneer een bestaande declaratie de node dekt.',
        clusterAddress: 'Cluster-adres',
        clusterAddressHint: 'Verplicht: het cluster-subnet staat apart en de node is daarop nog niet gedeclareerd.',
        noAddresses: 'De IPAM kent geen enkel adres van deze node binnen het subnet',
        error: 'De toevoeging van de mon is geweigerd'
      },
      removeMon: {
        title: 'MON weghalen',
        body: 'De MON en de MGR die ernaast draait verlaten node {node}. Op een uitgerold cluster worden de daemons gestopt en uit het quorum gehaald.',
        error: 'Het weghalen van de MON is geweigerd'
      },
      addMgr: {
        title: 'MGR toevoegen',
        node: 'Node',
        hint: 'Geavanceerd (MON/MGR los van elkaar): een standalone manager ontstaat op de gekozen lidnode via een task met node-affiniteit. De active/standby-verkiezing van Ceph kiest zelf de actieve MGR.',
        error: 'De toevoeging van de MGR is geweigerd'
      },
      removeMgr: {
        title: 'MGR weghalen',
        body: 'De standalone MGR verlaat node {node}. Op een uitgerold cluster wordt de daemon gestopt en zijn toestand verwijderd; de MON van de node (als die er is) blijft onaangeroerd.',
        error: 'Het weghalen van de MGR is geweigerd'
      },
      addMds: {
        title: 'MDS toevoegen',
        node: 'Node',
        hint: "De metadataserver van CephFS: ontstaat op de gekozen lidnode via een task met node-affiniteit, onder toezicht van de worker net als MON en MGR. Ceph kiest zelf actieven en standby's — één actieve plus één standby bedienen een bestandssysteem prima.",
        error: 'De toevoeging van de MDS is geweigerd'
      },
      removeMds: {
        title: 'MDS weghalen',
        body: 'De MDS verlaat node {node}. Op een uitgerold cluster wordt de daemon gestopt en zijn toestand verwijderd; de API weigert de laatste MDS zolang een bestandssysteem hem nodig heeft.',
        error: 'Het weghalen van de MDS is geweigerd'
      },
      split: {
        title: 'MON/MGR los van elkaar',
        label: 'MON en MGR op losse nodes toestaan',
        hint: "Uit (standaard) = de geratificeerde standaard: bij elke MON draait een MGR mee, één enkel lidmaatschap. Aan = het lidmaatschap van de MGR's staat op zichzelf en beheer je met de acties MGR toevoegen/weghalen op het tabblad Beheernodes.",
        enable: 'Inschakelen',
        disable: 'Uitschakelen',
        enableBody: "Het lidmaatschap van de MGR's wordt onafhankelijk van de MON's, geïnitialiseerd vanuit de huidige colocatie. De losse acties MGR toevoegen/weghalen komen beschikbaar op het tabblad Beheernodes. Dit versoepelt de standaard van het platform — houd het alleen aan als je weet waarom je het nodig hebt.",
        disableBody: "Terug naar de standaardcolocatie: een MGR bij elke MON, één enkel lidmaatschap. Alleen toegestaan zolang het lidmaatschap van de MGR's al samenvalt met dat van de MON's — breng ze eerst op één lijn met MGR toevoegen/weghalen, anders weigert de API.",
        error: 'De wijziging is geweigerd'
      },
      rawEditor: {
        title: 'Ruwe CRUSH-editor',
        label: 'De ruwe editor van de crushmap tonen op het tabblad CRUSH',
        hint: 'Uit (standaard) = het begeleide oppervlak van de regels is het standaardgereedschap. Aan = het tabblad CRUSH toont ook de gedecompileerde crushmap als bewerkbare tekst. Opslaan vraagt altijd sudo en de naam van het cluster als bevestiging, en gaat door compile + test van crushtool VOORDAT het het cluster bereikt.'
      },
      osdFlags: {
        section: 'Globale OSD-vlaggen',
        title: 'Override van de OSD-vlaggen',
        notObserved: 'nog niet waargenomen',
        standardFlowsHint: 'De standaardstromen van het platform beheren deze vlaggen in de normale gevallen zelf (het onderhoud van een node zet een gerichte noout, de vervanging van een schijf loopt via de levenscyclus van de OSD). Deze sectie is de handmatige override voor de operator die weet wat hij doet.',
        notDeployedGuard: 'OSD-vlaggen bestaan alleen op een uitgerold cluster',
        set: 'Vlag zetten',
        unset: 'Vlag weghalen',
        setBody: 'De globale vlag {flag} wordt GEZET op de osdmap. Hij blijft staan tot hij expliciet wordt weggehaald — een vergeten vlag degradeert het zelfherstel van het cluster.',
        unsetBody: 'De globale vlag {flag} wordt WEGGEHAALD van de osdmap.',
        error: 'De wijziging van de vlag is geweigerd',
        flag: {
          noout: 'Geen enkele OSD wordt als out uit de dataverdeling gemarkeerd — geen herbalancering wanneer een daemon wegvalt',
          norebalance: 'De herbalancering van de data is opgeschort',
          nobackfill: 'De backfill is opgeschort',
          norecover: 'De recovery is opgeschort',
          pause: 'ALLE I/O van de clients staat op pauze (lezen en schrijven)',
          noin: "OSD's die opstarten worden niet automatisch als in gemarkeerd",
          nodown: "Onbereikbare OSD's worden niet als down gemarkeerd — maskeert echte storingen"
        }
      },
      pools: {
        section: 'Pools',
        create: 'Pool aanmaken',
        createGuard: 'Pools bestaan alleen op een uitgerold cluster',
        notObserved: 'Nog geen waarneming van de pools — de sweep van de mon rapporteert hier',
        empty: 'Nog geen pool op het cluster',
        colName: 'Naam',
        colReplication: 'Size / min size',
        colPgNum: "PG's",
        colApplication: 'Applicatie',
        colRule: 'CRUSH-regel',
        colUsage: 'Gebruik',
        observedAtLabel: 'Waargenomen op',
        objects: '{n} objecten',
        inUseBy: 'in gebruik door {name}',
        internalGuard: 'Interne pool van Ceph — het platform verwijdert hem nooit',
        delete: 'Pool verwijderen',
        deleteGuard: 'Verbruikt door storage {name} — verwijder eerst de storage',
        hint: 'Alleen gerepliceerde pools (erasure coding valt buiten de scope van v1). De replicatie woont in Ceph: deze tabel is de waargenomen waarheid uit de sweep van de mon.',
        createTitle: 'Pool aanmaken',
        createHint: 'De pool ontstaat op het cluster met de gevraagde replicatie en de applicatie rbd ingeschakeld — het werk doet een task op een MON-node. Zet "Voorstellen als storage" aan om hem meteen in dezelfde handeling te verbruiken.',
        name: 'Naam van de pool',
        nameHint: 'DNS-veilig (kleine letters, cijfers, koppeltekens).',
        size: "Replica's (size)",
        sizeHint: 'Kopieën van elk object. Standaard 3.',
        minSize: "Minimum aantal replica's (min_size)",
        minSizeHint: 'Minimum aantal kopieën om I/O te bedienen — volgt size − 1 tot je het wijzigt.',
        createError: 'Het aanmaken van de pool is geweigerd',
        deleteTitle: 'Pool verwijderen',
        deleteBody: 'De pool {pool} en ELK object erin worden onherroepelijk vernietigd. Typ de naam van de pool om te bevestigen.',
        confirmLabel: 'Naam van de pool',
        confirmHint: 'Typ de naam van de pool om te bevestigen',
        deleteError: 'Het verwijderen van de pool is geweigerd',
        detailTitle: 'Details van de pool',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Ingeschakeld',
        autoscalerOff: 'Uitgeschakeld',
        autoscalerWarn: 'Melden',
        pgNumLabel: "Aantal PG's",
        pgNumCaption: 'Waargenomen: de autoscaler kan het zelfstandig wijzigen — dit veld schrijft een wens.',
        storage: 'Bijbehorende TVirt-storage',
        addAsStorage: 'Als TVirt-storage toevoegen',
        ruleSudoHint: 'Het wijzigen van de CRUSH-regel vraagt het wachtwoord van de operator.',
        updateError: 'De wijziging van de pool is geweigerd',
        updated: 'Wijziging van de pool gestart — de waarneming volgt vanzelf'
      },
      crush: {
        section: 'CRUSH-regels',
        notObserved: 'Nog geen CRUSH-waarneming — de sweep van de mon rapporteert hier',
        empty: 'Geen regel waargenomen op het cluster',
        hint: 'Een regel beslist WAAR de kopieën van elk object terechtkomen — haar faaldomein is de eenheid die kan uitvallen zonder dat er data verloren gaat. Pools wijzen naar een regel; de ingebouwde replicated_rule (één replica per server) is de standaard bij de geboorte.',
        create: 'Regel aanmaken',
        createGuard: 'CRUSH-regels bestaan alleen op een uitgerold cluster',
        createTitle: 'CRUSH-regel aanmaken',
        createHint: 'Eén regel = één keuze van faaldomein. De regel ontstaat gerepliceerd op de standaardroot — het werk doet een task op een MON-node; koppel de pools daarna vanaf het tabblad Pools.',
        createError: 'Het aanmaken van de regel is geweigerd',
        name: 'Naam van de regel',
        nameHint: 'DNS-veilig (kleine letters, cijfers, koppeltekens).',
        domain: 'Faaldomein',
        domainChoice: {
          osd: 'Elke replica op een andere OSD',
          host: 'Elke replica op een andere server',
          rack: 'Elke replica in een ander rack'
        },
        domainCustom: 'Aangepast (met de hand geschreven steps)',
        domainOther: 'Elke replica in een andere {type}',
        rackGuardHint: 'In de waargenomen hiërarchie bestaat geen enkele rack-bucket: de regel is toch aan te maken, maar geen enkele pool kan ernaar wijzen zolang er geen rack is gedeclareerd in de plaatsing van de lidservers (instellingen van de node) — de task die alles weer op één lijn brengt bouwt de bucket en de koppeling gaat vanzelf open.',
        treeTitle: 'Waargenomen hiërarchie',
        treeNotObserved: 'Nog geen waarneming van de hiërarchie — de sweep van de mon rapporteert hier',
        treeOsds: '{n} OSD',
        treeHint: "De CRUSH-map zoals het cluster hem ziet: root → gedeclareerde niveaus → servers (hosts) → OSD's. De topologie volgt de gedeclareerde plaatsing van elke server (instellingen van de node) — een wijziging van de positie brengt haar via een task weer op één lijn.",
        unplacedWarning: 'Leden zonder gedeclareerde positie: {nodes} — hun hosts blijven direct onder de root, buiten de gedeclareerde topologie. Declareer de positie in de instellingen van de node (een waarschuwing, nooit een blokkade).',
        colName: 'Naam',
        colDomain: 'Faaldomein',
        colPools: 'Pools',
        builtinChip: 'ingebouwd',
        builtinGuard: 'De standaardregel van het cluster — het platform verwijdert haar nooit',
        detailAction: 'Detail van de regel',
        detailType: 'Type',
        backToRules: 'Regels',
        ruleNotObserved: 'De waargenomen lijst met regels noemt deze regel niet',
        noPools: 'Geen enkele pool gebruikt deze regel',
        delete: 'Regel verwijderen',
        deleteTitle: 'CRUSH-regel verwijderen',
        deleteBody: 'De regel {rule} wordt uit de crushmap van het cluster gehaald. Geen enkele pool mag haar gebruiken. Typ de naam van de regel om te bevestigen.',
        deleteGuard: 'Gebruikt door pool {name} — wijs de pool eerst een andere regel aan',
        confirmLabel: 'Naam van de regel',
        confirmHint: 'Typ de naam van de regel om te bevestigen',
        deleteError: 'Het verwijderen van de regel is geweigerd',
        changeRule: 'CRUSH-regel wijzigen',
        changeRuleTitle: 'CRUSH-regel wijzigen',
        changeRuleHint: 'De pool gaat zijn objecten volgens de gekozen regel plaatsen — Ceph verplaatst de bestaande data om zich eraan te houden (op een volle pool volgt een herbalancering).',
        changeRuleError: 'De regelwijziging is geweigerd',
        rule: 'CRUSH-regel',
        rawTitle: 'Ruwe crushmap (gedecompileerd)',
        rawWarning: 'GEVAAR: deze tekst is het HELE plaatsingsbeleid van het cluster. Een verkeerde map kan de plaatsing van alle pools in één klap breken. Opslaan compileert en beproeft de map met crushtool VOORDAT hij wordt geïnjecteerd — maar een geldige map kan alsnog een slecht idee zijn.',
        rawReload: 'Herladen',
        rawLoading: 'Query loopt — een read-only task is de crushmap aan het decompileren…',
        rawSave: 'Crushmap opslaan',
        rawSaveTitle: 'Crushmap injecteren',
        rawSaveBody: 'De bewerkte tekst vervangt de crushmap van het HELE cluster na compile + test van crushtool. Typ de naam van het cluster om te bevestigen.',
        rawConfirmLabel: 'Naam van het cluster',
        rawConfirmHint: 'Typ {name} om te bevestigen',
        rawError: 'De bewerking op de crushmap is mislukt',
        rawHint: 'De tekst is de vorm crushtool -d. Compilatie- en testfouten komen woord voor woord terug van crushtool — de map bereikt het cluster niet als een van beide controles faalt.'
      },
      objects: {
        poolsSection: 'Objectverkenner',
        poolsHint: 'Kies een pool om zijn RBD-images op te sommen. Elke diepe lezing loopt als read-only task op een MON-node — hij blokkeert de echte operaties niet (en wordt er niet door geblokkeerd).',
        deployedGuard: "Query's op de objecten antwoorden alleen op een uitgerold cluster",
        browse: 'Objecten doorbladeren',
        detailAction: 'Detail van de image',
        backToPools: 'Pools',
        backToImages: 'Images',
        refresh: 'Vernieuwen',
        loading: 'Query loopt — een read-only task ondervraagt het cluster…',
        error: 'De query is mislukt',
        retry: 'Opnieuw proberen',
        notRbd: 'Pool met application "{app}" — hij bevat geen RBD-images, hier valt niets te verkennen',
        noImages: 'Geen RBD-image in deze pool',
        colImage: 'Image',
        colSize: 'Grootte',
        colObjects: 'Objecten',
        colSnapshots: 'Snapshots',
        imagesHint: 'De schijven op een verbruikende rbd-storage zijn images met de naam van hun schijf-id. Het aantal objecten is het provisioned aantal (grootte / objectgrootte) — het werkelijke gebruik woont in het detail van de image.',
        infoTitle: 'Image',
        infoSize: 'Virtuele grootte',
        infoObjects: 'Objecten (provisioned)',
        infoObjectSize: 'Objectgrootte',
        infoPrefix: 'Objectprefix',
        infoFormat: 'Formaat',
        infoFeatures: 'Features',
        usageTitle: 'Werkelijk gebruik (rbd du)',
        usageOf: 'van {provisioned} GiB provisioned',
        usageHint: 'Thin van nature: alleen geschreven objecten bezetten bytes.',
        watchersTitle: 'Watchers',
        noWatchers: 'Geen watcher — niemand heeft deze image nu open',
        snapshotsTitle: 'RBD-snapshots',
        noSnapshots: 'Geen RBD-snapshot op deze image',
        colSnapshot: 'Snapshot',
        colProtected: 'Beschermd',
        colTimestamp: 'Aangemaakt',
        protected: 'beschermd',
        mappingTitle: 'Fysieke plaatsing (OSD-set)',
        mappingSampled: "Steekproef van {sampled} objecten op {total} — een eerlijke samenvatting: bij grote images convergeert de set naar ALLE OSD's van de pool (CRUSH verdeelt de objecten over de hele pool).",
        mappingComplete: 'Alle objecten gemapt ({total} van {total}).',
        objectQueryTitle: 'Eén enkel object mappen',
        objectName: 'Naam van het object',
        objectHint: 'RADOS-objectnamen zijn <prefix>.<16-hex-index> — ceph osd map antwoordt met de PG- en OSD-sets.',
        mapObject: 'Mappen',
        primary: 'primair: osd.{osd}'
      },
      registerDevice: {
        title: 'OSD-apparaat registreren',
        hint: 'Op een levend cluster BEREIDT de registratie het apparaat ook voor: het wordt een BlueStore-OSD via een automatische task met node-affiniteit (nooit leeg, geratificeerd 2026-07-24). Een apparaat hoort in de hele fleet bij hooguit één Ceph-cluster.',
        disk: 'Dataschijf',
        diskHint: 'De gedeclareerde dataschijven van de node — naam en serienummer',
        noDeclared: 'Geen dataschijf gedeclareerd op deze node — markeer ze eerst in de lokale instellingen van de node',
        serialHint: 'Het serienummer van het apparaat — de identiteitspin',
        encrypted: 'Deze OSD versleutelen (dmcrypt)',
        encryptedHint: 'De keuze per OSD (de modus van het cluster is "per OSD gekozen"): ze bevriest bij de registratie op deze schijf — een latere moduswijziging schrijft haar nooit over; de rij-actie versleutelen/ontsleutelen doet dat wel.',
        error: 'De registratie is geweigerd'
      },
      unregisterDevice: {
        title: 'Apparaat deregistreren',
        body: 'Alleen het register: {name} is geen OSD-kandidaat van dit cluster meer. Zijn bytes blijven onaangeroerd.',
        error: 'De deregistratie is geweigerd'
      },
      deploy: {
        action: 'Uitrol opnieuw proberen',
        title: 'De bootstrap opnieuw proberen',
        body: 'De bootstrap van de geboorte start opnieuw vanuit de huidige configuratie: de mons komen op, elk geregistreerd apparaat wordt voorbereid en geactiveerd als BlueStore-OSD. De bewerking loopt als macrotask — de fase volgt vanzelf.',
        started: 'Bootstrap gestart — hij gaat verder als macrotask; de fase volgt vanzelf',
        error: 'De bootstrap is geweigerd'
      },
      propose: {
        action: 'Voorstellen als storage',
        title: 'Voorstellen als storage',
        hintPool: 'De bestaande pool {name} wordt een TVirt-storage: een cephx-identiteit begrensd tot de pool belandt in de keystore en de ceph-rbd-storage ontstaat gebruiksklaar. Het voorstel verbruikt de pool — het maakt er nooit een aan.',
        hintFs: 'Het bestaande bestandssysteem {name} wordt een TVirt-storage: een cephx-identiteit begrensd tot het bestandssysteem belandt in de keystore en de cephfs-storage ontstaat gebruiksklaar en gemount. Het voorstel verbruikt het bestandssysteem — het maakt er nooit een aan.',
        name: 'Naam van de storage',
        nameHint: 'DNS-1123, uniek binnen de scope — de cephx-identiteit is naar hem vernoemd.',
        path: 'Pad binnen het bestandssysteem',
        pathHint: 'Absoluut pad binnen het bestandssysteem dat de storage mount — / bij twijfel.',
        alsoPropose: 'Meteen voorstellen als storage',
        alsoProposePoolHint: 'Na het aanmaken stelt dezelfde handeling de pasgeboren pool voor als ceph-rbd-storage — twee expliciete aanroepen, één dialoog.',
        alsoProposeFsHint: 'Na het aanmaken stelt dezelfde handeling het pasgeboren bestandssysteem voor als cephfs-storage — twee expliciete aanroepen, één dialoog.',
        guard: 'Voorstellen als storage — alleen op een gezond cluster',
        started: 'Voorstel geaccepteerd — de storage wordt gematerialiseerd; je vindt hem onder Storage',
        submit: 'Storage aanmaken',
        error: 'Het voorstel is geweigerd'
      },
      fs: {
        section: 'Bestandssystemen',
        create: 'Bestandssysteem aanmaken',
        createGuard: 'Bestandssystemen bestaan alleen op een uitgerold cluster',
        mdsFirstGuard: 'Voeg eerst een MDS toe — een bestandssysteem zonder metadataserver ontstaat onbruikbaar',
        notObserved: 'Nog geen waarneming van de bestandssystemen — de sweep van de MON rapporteert hier',
        empty: 'Nog geen bestandssysteem op het cluster',
        colName: 'Naam',
        colPools: 'Pools',
        colMds: 'MDS',
        noActiveMds: 'geen actieve MDS',
        delete: 'Bestandssysteem weghalen',
        deleteGuard: 'Verbruikt door storage {name} — verwijder eerst de storage',
        hint: 'Een bestandssysteem bezit zijn eigen data- en metadatapools (cephfs.<naam>.data / .meta): ze ontstaan met hem en sterven met hem — removeFs, nooit een losse pool-delete met de hand. Deze tabel is de waargenomen waarheid uit de sweep van de MON.',
        createTitle: 'Bestandssysteem aanmaken',
        createHint: 'Het bestandssysteem ontstaat op het cluster met zijn twee pools (application cephfs) en wordt bediend door de gedeclareerde MDS-daemons — het werk doet een task op een MON-node. Zet "Voorstellen als storage" aan om het meteen in dezelfde handeling te verbruiken.',
        name: 'Naam van het bestandssysteem',
        nameHint: 'DNS-veilig (kleine letters, cijfers, koppeltekens).',
        sizeHint: "Replica's van BEIDE nieuwe pools. Standaard 3.",
        createError: 'Het aanmaken van het bestandssysteem is geweigerd',
        deleteTitle: 'Bestandssysteem weghalen',
        deleteBody: 'Het bestandssysteem {fs} en ELK bestand erin worden onherroepelijk vernietigd — zijn data- en metadatapools sterven met hem mee. Typ de naam van het bestandssysteem om te bevestigen.',
        confirmLabel: 'Naam van het bestandssysteem',
        confirmHint: 'Typ de naam van het bestandssysteem om te bevestigen',
        deleteError: 'Het weghalen van het bestandssysteem is geweigerd'
      },
      destroy: {
        action: 'Vernietigen',
        retryAction: 'De vernietiging opnieuw proberen',
        retryGuard: 'De vernietiging loopt — de nieuwe poging geldt voor een mislukte vernietiging (anders weigert de lease hem)',
        title: 'Het cluster vernietigen',
        body: 'De uitgerolde fabric wordt afgebroken: elke daemon van dit cluster stopt, zijn systeemtoestand en de sleutels in de keystore worden vrijgegeven. Zodra de vernietiging is geslaagd, wordt het cluster automatisch verwijderd.',
        confirmLabel: 'Naam van het cluster',
        confirmHint: 'Typ de naam van het cluster om te bevestigen',
        wipe: 'De geregistreerde apparaten wissen',
        wipeHint: 'Aangevinkt: de handtekeningen van elk geregistreerd apparaat worden gewist — de data erop wordt vernietigd. Niet aangevinkt: de bytes blijven intact en de apparaten keren terug naar geregistreerd.',
        guard: 'Vernietigen — er is niets uitgerold',
        started: 'Vernietiging gestart — ze gaat verder als macrotask; de fase volgt vanzelf',
        error: 'De vernietiging is geweigerd'
      },
      delete: {
        guard: 'Verwijderen — alleen een niet-uitgerolde configuratie (vernietig hem eerst)',
        title: '{name} verwijderen?',
        body: 'De configuratie en zijn apparatenregister worden verwijderd. Alleen toegestaan zolang er niets is uitgerold.',
        error: 'De verwijdering is geweigerd'
      }
    }
  }
}
